// extracted by mini-css-extract-plugin
export default {"tooltip":"MainChart_tooltip__icunU","tooltipHr":"MainChart_tooltipHr__HxvL9","totalPointPer":"MainChart_totalPointPer__FQkSE","tooltipUl":"MainChart_tooltipUl__-2TqF"};